import React, { PureComponent } from 'react'
import { Button, ButtonToolbar } from 'reactstrap'
import { reduxForm } from 'redux-form'
import { Question } from './Question'
import uuid from 'uuid'

class WizardFormOne extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showPassword: false
    }

    this.showPassword = this.showPassword.bind(this)
  }

  showPassword (e) {
    e.preventDefault()
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  render () {
    const { handleSubmit, previousPage } = this.props

    return (
      <form className='form wizard__form' onSubmit={handleSubmit}>
        <div className='form__form-group'>
          {
            this.props.data.map(data => {
              return <Question
                helpText={data.helpText}
                question={data.question}
                answers={data.answers}
                key={uuid()} />
            })
          }
        </div>
        <ButtonToolbar className='form__button-toolbar wizard__toolbar'>
          <Button color='primary' type='button' disabled className='previous' onClick={previousPage}>Back</Button>
          <Button color='primary' type='submit' className='next'>Next</Button>
        </ButtonToolbar>
      </form>
    )
  }
}

export default reduxForm({
  form: 'wizard', //                 <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
})(WizardFormOne)



// WEBPACK FOOTER //
// ./src/components/assessment/components/WizardFormOne.js